import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import './locationMasterModal.css';
import CreateEdit from './CreateEdit';

function LocationmasterCreateModal({ handleClose,setNewValue,type,customerId }) {
  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={true} onClose={handleClose}>
      <DialogContent className="modalContainer">
        <CreateEdit
          setNewValue={setNewValue}
          closeCreateEditForm={handleClose}
          LocationEditDatas={null}
          editStatus={false}
          customerId={customerId}
          type={type}
        />
      </DialogContent>
    </Dialog>
  );
}

export default LocationmasterCreateModal;
